export default __webpack_public_path__ + "static/media/map-icon-guide.665b918b.svg";